import { UsersPage } from './views';

const routes = [
    {
        path: '/users',
        name: 'users',
        component: UsersPage,
        meta: {
            title: 'Users Speechki',
            navLabel: 'Users',
        },
        navDisplay: true,
    },
];

export default routes;
